module.exports = __webpack_public_path__ + "static/img/bg-hssfalk.5078c4b.png";